export default "__VITE_ASSET__BApqJqAz__"